'use strict';

(function (angular) {

    angular.module('zp').factory('VenueModel', venueModelFactory);

    /**ngInject */
    function venueModelFactory() {

        var defaultImage = 'https://dl.dropboxusercontent.com/s/yhyv1zzulx7v5ou/1.jpg';

        function VenueModel(data, galleryLimit) {

            this.id = data && data.id ? data.id : null;
            this.name = data && data.name ? data.name : '';
            this.city = data && data.city ? data.city : '';
            this.address = data && data.address ? data.address : this.city;
            this.apartment = data && data.apartment ? data.apartment : 0;
            this.decoration = data && data.decoration ? data.decoration : 0;
            this.music = data && data.music ? data.music : 0;
            this.photograph = data && data.photograph ? data.photograph : 0;
            this.discount = data && data.discount ? true : false;
            this.discountValue = data && data.discount ? data.discount : 'Nema';
            this.image = data && data.image ? data.image.replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/').replace('?dl=1', '') : defaultImage;
            this.images = data && data.gallery && data.gallery.length ? getGallery(data.gallery, galleryLimit) : [{ url: defaultImage }];
            this.duration = data && data.duration ? data.duration : '';
            this.email = data && data.email ? data.email : '';
            this.facebook = data && data.facebook ? data.facebook : '';
            this.instagram = data && data.instagram ? data.instagram : '';
            this.maxCapacity = data && data.maxCapacity ? data.maxCapacity : '';
            this.minCapacity = data && data.minCapacity ? data.minCapacity : '';
            this.parking = data && data.parking ? data.parking : '';
            this.phone = data && data.phone ? data.phone : '';
            this.type = data && data.type ? data.type : '';
            this.website = data && data.website ? data.website : '';
            this.shares = data && data.shares ? data.shares : 0;
            this.likes = data && data.likes ? data.likes : 0;
            this.comments = data && data.comments ? data.comments : 0;
            this.stickers = data && data.stickers ? data.stickers : [];
            this.location = data && data.location ? data.location : { address: this.address, latitude: null, longitude: null };
            this.description = data && data.description ? data.description : '';
            this.category = data && data.category ? data.category : 'prostori';
            this.google = data && data.google ? data.google : '';
            this.youtube = data && data.youtube ? data.youtube : '';
            this.twitter = data && data.twitter ? data.twitter : '';
            this.favsCount = data && data.favsCount ? data.favsCount : 0;
            this.likeCount = data && data.likeCount ? data.likeCount : 0;
        }

        VenueModel.prototype.fromVendorRaw = function (data, galleryLimit) {
            this.id = data && data.id ? data.id : null;
            this.name = data && data.name ? data.name : '';
            this.city = data && data.city ? data.city : '';
            this.address = data && data.address ? data.address : this.city;
            this.apartment = data && data.apartment ? data.apartment : 0;
            this.image = data && data.image ? data.image.replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/').replace('?dl=1', '') : defaultImage;
            this.images = data && data.gallery && data.gallery.length ? getGallery(data.gallery, galleryLimit) : [{ url: defaultImage }];
            this.email = data && data.email ? data.email : '';
            this.facebook = data && data.facebook ? data.facebook : '';
            this.instagram = data && data.instagram ? data.instagram : '';
            this.phone = data && data.phone1 ? data.phone1 : '';
            this.type = data && data.type ? data.type : '';
            this.website = data && data.website ? data.website : '';
            this.google = data && data.google ? data.google : '';
            this.youtube = data && data.youtube ? data.youtube : '';
            this.twitter = data && data.twitter ? data.twitter : '';
            this.location = data && data.location ? data.location : { address: this.address, latitude: null, longitude: null };
            this.description = data && data.description ? data.description : '';
            this.category = data && data.category ? data.category : 'prostori';
            this.favsCount = data && data.favsCount ? data.favsCount : 0;
            this.likeCount = data && data.likeCount ? data.likeCount : 0;
        };

        function getGallery(rawGallery, limit) {
            var res = [];
            if (!limit) {
                limit = rawGallery.length;
            } else {
                limit = Math.min(rawGallery.length, limit);
            }
            for (var i = 0; i < limit; i++) {
                res.push({ url: rawGallery[i].replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/').replace('?dl=1', '') });
            }
            return res;
        }

        return VenueModel;
    }
})(window.angular);